
if (!customElements.get('offers-promo-block')) {
    class OffersPromoBlock extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.setupEventlisteners();
            this.playing = false;
            this.otherPromoBlocks = document.querySelectorAll('offers-promo-block:not(#' + this.id + ')');
        }

        setupEventlisteners() {
            const video = this.querySelector('video');
            if (video) {
                this.addEventListener('click', () => {
                    if (this.playing) {
                        this.muteVideo(video, this);
                    } else {
                        this.startVideo(video, this);
                        // mute all other promo videos on the page
                        this.otherPromoBlocks?.forEach(otherpromo => {
                            const otherpromovideo = otherpromo.querySelector('video');
                            if (otherpromovideo) this.muteVideo(otherpromovideo, otherpromo)
                        })
                    }
                });
            }
        }

        muteVideo(video, promo) {
            if (!video || !promo) return;
            promo.classList.remove('playing');
            promo.playing = false;
            video.muted = true;
        }

        startVideo(video, promo) {
            if (!video || !promo) return;
            promo.classList.add('playing');
            video.currentTime = 0;
            video.muted = false;
            promo.playing = true;
        }
    }

    customElements.define('offers-promo-block', OffersPromoBlock);
}